// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_p-6";
export var headerCell = "_p-2";
export var loadingStateContent = "_p-8";
export var rowWrapper = "_p-4";
export var stickyAggregationCell = "_p-b";
export var stickyAggregationRow = "_p-7";
export var stickyColumnCell = "_p-a";
export var stickyColumnHeaderCell = "_p-9";
export var table = "_p-1";
export var virtualRowWrapper = "_p-5";
export var virtualTableBodyFiller = "_p-d";
export var virtualTableBodyFillerBottom = "_p-e";
export var virtualTableContainer = "_p-0";
export var virtualTableContainerFill = "_p-c";
export var white = "_p-3";